import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "@Services/axiosWrapper";
import { deleteIssuesData } from "./issues";
import { showToastNotification } from "@Reducers/toastSlice";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { t } from "@i18n";
import type { DeleteIssuesDataRequest, DeleteIssuesDataResponse } from "@ServerTypes/issues/issues.schema.js";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

export function deleteIssueData(id: ObjectIdString[]) {
  return async (dispatch: AppDispatch) => {
    const data: DeleteIssuesDataRequest = { id };
    const response = await axiosWrapper.post<DeleteIssuesDataResponse>(
      `${getBackendUrl()}/issues/deleteIssuesData`,
      data,
    );
    if (response.data.status) {
      dispatch(deleteIssuesData(id));
      dispatch(
        showToastNotification({
          content: t("Selected Issues have been deleted Successfully"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(showToastNotification({ content: SOMETHING_WENT_WRONG, type: TOAST_TYPE_ERROR }));
    }
  };
}
